import { Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'

import * as Styled from './styles'

interface SingleCardSelectCardProps {
  disabled?: boolean
  hasError?: boolean
  id: number
  isSelected: boolean
  label: string
  onClick: (id: number) => void
}

export const SingleCardSelectCard = ({
  disabled,
  hasError,
  id,
  isSelected,
  label,
  onClick,
}: SingleCardSelectCardProps): ReactElement => {
  const handleCardClick = useCallback(() => onClick(id), [id, onClick])

  return (
    <Styled.SingleCardSelectCardWrapper
      disabled={disabled}
      hasError={hasError}
      isSelected={isSelected}
      onClick={handleCardClick}
      type="button"
    >
      <Text variant="bodyLG">{label}</Text>
    </Styled.SingleCardSelectCardWrapper>
  )
}
